var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.237 3.31707C12.3942 1.77845 7.73063 2.65582 5.02083 5.6434L5.02061 5.64364C3.6865 7.11377 2.84976 8.96774 2.62954 10.9416C2.40931 12.9154 2.81683 14.9085 3.79406 16.637C4.77129 18.3655 6.26842 19.7413 8.07227 20.5686C9.87612 21.3959 11.8947 21.6324 13.8407 21.2445L13.841 21.2444C17.7564 20.465 20.6745 16.9214 21.4534 13.0229C21.5927 12.326 22.27 11.874 22.9663 12.0134C23.6625 12.1528 24.114 12.8307 23.9748 13.5277C23.0396 18.2084 19.4952 22.743 14.3425 23.7687C11.866 24.2623 9.29697 23.9613 7.00127 22.9085C4.70546 21.8556 2.80002 20.1045 1.55627 17.9046C0.312522 15.7047 -0.206135 13.168 0.0741513 10.6559C0.354426 8.14386 1.41929 5.78436 3.11712 3.91332M3.11734 3.91308C6.6266 0.0443144 12.4639 -0.965679 17.192 0.927373C17.8512 1.19133 18.1719 1.94026 17.9082 2.60016C17.6445 3.26006 16.8963 3.58103 16.237 3.31707M23.5861 3.75039C24.1079 4.23246 24.1404 5.04663 23.6588 5.56887L13.3737 16.7219C13.1364 16.9793 12.8045 17.1287 12.4547 17.1357C12.1049 17.1427 11.7674 17.0067 11.52 16.759L7.2345 12.4694C6.73243 11.9668 6.73243 11.152 7.2345 10.6494C7.73657 10.1469 8.55059 10.1469 9.05266 10.6494L12.3919 13.992L21.7694 3.82313C22.251 3.30088 23.0644 3.26832 23.5861 3.75039Z",
    fill: "#19BC28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheck);
export default __webpack_public_path__ + "static/media/CircleCheck.959cbd14700168b5edcb10da8420240b.svg";
export { ForwardRef as ReactComponent };